// extracted by LIB_CSS_EXTRACT_LOADER
import "./flip-button_module.css"
export default {"button":"button-xnaeSA","face":"face-i7p2h4","front":"front-wlGqoF","back":"back-g4U4Lz","measure":"measure-MK5wm8"};